// ============================================================================
// PSP Style Tokens
// ============================================================================

// Card fields of the PSP checkouts live in iframes, so page CSS never reaches them - only the
// SDK's own style option does. These are the values our checkout skin uses today (Adyen via
// PaymentPage.css / Stripe via its appearance object), kept in one place for PSP style configs.
// StripeCheckoutForm keeps its own appearance object (its danger colour differs).

export const PSP_FONT_FAMILY = 'Roboto, sans-serif';

// Same Roboto weights as core.css, loaded into the PSP iframes
export const PSP_FONT_STYLESHEET = 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap';

export const PSP_STYLE_TOKENS = {
  colorText: '#1e2d50',
  colorLabel: '#687282',
  colorDanger: '#ef4747',           // --primary-danger
  colorPrimary: '#269c6e',          // --primary-lightgreen
  colorBackground: '#ffffff',

  input: {
    height: 56,
    borderColor: '#d9dce1',
    borderWidth: 1,
    borderRadius: 5,
    fontSize: '14px',
    fontWeight: '500',
    focusBorderColor: '#0075ff',
    focusBoxShadow: '0 0 0 2px #99c2ff',
  },

  label: {
    fontSize: '13px',
    fontWeight: '700',
  },

  paymentMethod: {
    borderRadius: 5,
    selectedColor: '#269c6e',       // --primary-lightgreen
  },

  payButton: {
    background: 'linear-gradient(90deg, #269c6e 0%, #7aba47 100%)', // --primary-button-gradient
    height: 56,
    borderRadius: 12,               // CheckoutForms/StripeCheckout.css .stripe-pay-button
    fontSize: '16px',
    fontWeight: '700',
    color: '#ffffff',
  },

  // Rows of the flat payment method list (Primer headless checkout)
  paymentRow: {
    minHeight: 48,
    borderColor: '#d9dce1',
    borderRadius: 5,
    selectedColor: '#269c6e',
    background: '#ffffff',
  },
} as const;

// V3 Care+ payment skin (pages/v3/PaymentV3CarePlus/PaymentV3CarePlus.css)
export const PSP_STYLE_TOKENS_V3_CARE_PLUS = {
  borderRadius: 9,
  borderColor: '#dee3ed',
  selectedColor: '#f08e00',
} as const;
